import React from 'react';
import { usePage } from '@inertiajs/react';
import { Sidebar } from './Sidebar';

interface User {
  id: string;
  name: string;
  email: string;
  is_admin: boolean;
  avatar_image_url: string | null;
}

interface LayoutProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

interface PageProps {
  auth?: {
    user: User | null;
  };
  user?: User;
  routes?: {
    root: string;
    travels_index: string;
    travels_new: string;
    travels_create: string;
    sessions_new: string;
    sessions_create: string;
    sessions_destroy: string;
    approvals_index: string;
    people_index: string;
  };
  [key: string]: any;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  requireAuth = true
}) => {
  const { props } = usePage<PageProps>();
  const { auth, routes } = props;
  const user = auth?.user || props.user;

  return (
    <div className="flex h-screen bg-background">
      <Sidebar user={user} routes={routes} />
      <div className="flex-1 overflow-auto">
        <main className="p-1">
          {children}
        </main>
      </div>
    </div>
  );
};

export const PublicLayout: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      {children}
    </div>
  );
};
